/**
 * Hex-Encoding-Helper für Byte-Sequenzen.
 *
 * Wird vom SPKI-Fingerprint genutzt, um die ersten 8 Bytes der SHA-256-Hash-Summe
 * als 16-stelligen Lowercase-Hex-String darzustellen.
 */

const HEX_ALPHABET = '0123456789abcdef';
const NIBBLE_HIGH_SHIFT = 4;
const NIBBLE_LOW_MASK = 0x0f;

/**
 * Konvertiert ein Byte-Array in einen Lowercase-Hex-String.
 * Jedes Byte wird als zwei Hex-Zeichen ausgegeben (`00`–`ff`).
 *
 * @param bytes Beliebige Byte-Sequenz.
 * @returns Hex-String der Länge `bytes.length * 2`.
 */
export function bytesToHexLower(bytes: Uint8Array): string {
  const chars: string[] = new Array<string>(bytes.length * 2);
  for (let index = 0; index < bytes.length; index++) {
    const byte = bytes[index] ?? 0;
    chars[index * 2] = charAt(byte >> NIBBLE_HIGH_SHIFT);
    chars[index * 2 + 1] = charAt(byte & NIBBLE_LOW_MASK);
  }
  return chars.join('');
}

function charAt(nibble: number): string {
  const char = HEX_ALPHABET[nibble];
  if (char === undefined) {
    throw new RangeError(`Hex-Alphabet-Index out of range: ${nibble.toString()}`);
  }
  return char;
}
